/** @format */

import axios from "axios";
import {
  GET_200COINS_ERROR,
  GET_200COINS_REQUEST,
  GET_200COINS_SUCCESS,
  GET_BALANCE_ERROR,
  GET_BALANCE_REQUEST,
  GET_BALANCE_SUCCESS,
  GET_PORTFOLIO_DATA_ERROR,
  GET_PORTFOLIO_DATA_REQUEST,
  GET_PORTFOLIO_DATA_SUCCESS,
  GET_PRICE_ERROR,
  GET_PRICE_REQUEST,
  GET_PRICE_SUCCESS,
  GET_TRADE_ASSISTANT_SUCCESS,
  GET_TRADE_HISTORY_SUCCESS,
  RESET_HISTORY_ERROR,
  RESET_HISTORY_REQUEST,
  RESET_HISTORY_SUCCESS,
  SET_TRADING_ERROR,
  SET_TRADING_REQUEST,
  SET_TRADING_SUCCESS,
  GET_INVESTMENT_BUDGET_REQUEST,
  GET_INVESTMENT_BUDGET_SUCCESS,
  GET_INVESTMENT_BUDGET_ERROR,
  GET_TRADE_HISTORY_REQUEST,
  GET_TRADE_HISTORY_ERROR,
  GET_TRADE_ASSISTANT_REQUEST,
  GET_TRADE_ASSISTANT_ERROR,
  GET_ASSISTANT_REPORT_REQUEST,
  GET_ASSISTANT_REPORT_SUCCESS,
  GET_ASSISTANT_REPORT_ERROR,
  SET_LIMIT_ORDER_REQUEST,
  SET_LIMIT_ORDER_SUCCESS,
  SET_LIMIT_ORDER_ERROR,
  VIRTUAL_PORTFOLIO,
  SET_AI_MARKET_TYPE,
  UPDATE_PORTFOLIO_DATA,
  UPDATE_TRADE_ASSISTANT_DATA,
  SET_AI_ASSISTANT_MODE,
  GET_ALL_TRADE_SUGGESTION_REQUEST,
  GET_ALL_TRADE_SUGGESTION_SUCCESS,
  GET_ALL_TRADE_SUGGESTION_ERROR,
  SET_TIMEFRAME,
} from "./consts";
import { notify } from "../../utility/Toastify/toastify";
import { errorHandler } from "../../utility/helper";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";

let tradeAssistantRequestSeq = 0;
let suggestionAbort = null;
let suggestionOpenKey = "";
let suggestionRetryTimer = null;
const liveSuggestionTimers = [];
const SUGGESTION_RETRY_GAP_MS = 30000;

function clearSuggestionRetry() {
  if (suggestionRetryTimer) {
    clearTimeout(suggestionRetryTimer);
    suggestionRetryTimer = null;
  }
}

function suggestionRetryable(err) {
  const status = Number(err?.response?.status || 0);
  if (status === 504 || status === 500) return true;
  const body = err?.response?.data;
  const message = String(body?.message || body?.MESSAGE || "");
  return /internal server error/i.test(message);
}

function suggestionRequestKey(portfolioType, marketType, mode, forceRefresh) {
  return [portfolioType || "", marketType || "", mode || "", forceRefresh ? "1" : "0"].join("|");
}

function isCanceledRequest(err) {
  return axios.isCancel(err) || err?.code === "ERR_CANCELED" || err?.name === "CanceledError";
}

function clearLiveSuggestionTimers() {
  while (liveSuggestionTimers.length) {
    clearTimeout(liveSuggestionTimers.pop());
  }
}

export const setVirtualPortfolio = (portfolio) => {
  return { type: VIRTUAL_PORTFOLIO, payload: portfolio };
};

export const getPortfolioData =
  (
    email,
    user,
    portfolio_type,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_PORTFOLIO_DATA_REQUEST });

    const url =
      "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email: email,
      user: user,
      request_type: "get_portfolio",
      portfolio_type,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_PORTFOLIO_DATA_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getPortfolioData(email, user, portfolio_type, retryCount + 1),
          GET_PORTFOLIO_DATA_ERROR,
          user,
          email,
          formatTelegramLog("assistant/get_portfolio", data, url),
          0,
          currentPath,
        );
      });
  };

export const getTradeHistory =
  (
    email,
    user,
    portfolioType = "primary",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_TRADE_HISTORY_REQUEST });

    const url =
      "https://hav8w1xk8h.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email: email,
      user: user,
      request_type: "get_trade_history",
      portfolio_type: portfolioType,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_TRADE_HISTORY_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getTradeHistory(
              email,
              user,
              (portfolioType = "primary"),
              retryCount + 1,
            ),
          GET_TRADE_HISTORY_ERROR,
          user,
          email,
          formatTelegramLog("assistant/get_trade_history", data, url),
          0,
          currentPath,
        );
      });
  };

export const getTradeAssistant =
  (
    email,
    user,
    portfolio_type = "primary",
    market_type = "crypto",
    isActive,
    mode = null,
    forceRefresh = false,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch, getState) => {
    const requestKey = suggestionRequestKey(portfolio_type, market_type, mode, forceRefresh);
    if (suggestionOpenKey === requestKey) return;
    clearSuggestionRetry();

    const controller = new AbortController();
    const previousAbort = suggestionAbort;
    suggestionAbort = controller;
    suggestionOpenKey = requestKey;
    const requestId = ++tradeAssistantRequestSeq;
    clearLiveSuggestionTimers();
    dispatch({ type: GET_TRADE_ASSISTANT_REQUEST });
    if (previousAbort) previousAbort.abort();

    const requestPayload = {
      platform_mode: "trade_assistant",
      email,
      user,
      request_type: "get_trade_suggestion",
      portfolio_type,
      market_type,
    };

    if (mode !== "null" && mode) {
      requestPayload.ai_assistant_mode = mode;
    }
    if (forceRefresh) {
      requestPayload.cache = "False";
    }
    const url =
      "https://hav8w1xk8h.execute-api.ap-southeast-2.amazonaws.com/dev/api";

    const startedAt = Date.now();
    try {
      const res = await axios.post(url, requestPayload, { signal: controller.signal });
      if (requestId !== tradeAssistantRequestSeq) return;
      if (res?.data?.status === "error" || res?.data?.status === "failed") {
        dispatch({
          type: GET_TRADE_ASSISTANT_ERROR,
          payload: res?.data?.message || res?.data?.error || "Couldn't load the board.",
        });
        return;
      }
      dispatch({ type: GET_TRADE_ASSISTANT_SUCCESS, payload: res?.data });
    } catch (err) {
      if (requestId !== tradeAssistantRequestSeq) return;
      if (isCanceledRequest(err)) return;
      if (suggestionRetryable(err) && retryCount < 2) {
        const wait = Math.max(0, SUGGESTION_RETRY_GAP_MS - (Date.now() - startedAt));
        clearSuggestionRetry();
        suggestionRetryTimer = setTimeout(() => {
          suggestionRetryTimer = null;
          if (requestId !== tradeAssistantRequestSeq) return;
          dispatch(
            getTradeAssistant(
              email,
              user,
              portfolio_type,
              market_type,
              isActive,
              mode,
              forceRefresh,
              retryCount + 1,
              currentPath,
            ),
          );
        }, wait);
        return;
      }
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () =>
          getTradeAssistant(
            email,
            user,
            portfolio_type,
            market_type,
            isActive,
            mode,
            forceRefresh,
            retryCount + 1,
          ),
        GET_TRADE_ASSISTANT_ERROR,
        user,
        email,
        formatTelegramLog("get_trade_suggestion", requestPayload, url),
        0,
        currentPath,
        0,
      );
    } finally {
      if (suggestionAbort === controller) {
        suggestionAbort = null;
        suggestionOpenKey = "";
      }
    }
  };

export const getAssistantReport =
  (
    email,
    user,
    portfolio_type = "primary",
    market_type = "crypto",
    mode = null,
    forceRegenerate = false,
    cardSnapshot = [],
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_ASSISTANT_REPORT_REQUEST });

    const requestPayload = {
      platform_mode: "trade_assistant",
      email,
      user,
      request_type: "get_assistant_report",
      portfolio_type,
      market_type,
      force_regenerate: forceRegenerate ? "true" : "false",
    };
    if (mode !== "null" && mode) {
      requestPayload.ai_assistant_mode = mode;
    }
    if (Array.isArray(cardSnapshot) && cardSnapshot.length) {
      requestPayload.card_snapshot = cardSnapshot;
    }
    const browserLang = String(navigator.language || "").toLowerCase();
    requestPayload.lang = browserLang.startsWith("fa")
      ? "fa"
      : browserLang.startsWith("id")
        ? "id"
        : "en";
    const url =
      "https://hav8w1xk8h.execute-api.ap-southeast-2.amazonaws.com/dev/api";

    await axios
      .post(url, requestPayload)
      .then((res) => {
        if (res?.data?.status === "error") {
          dispatch({
            type: GET_ASSISTANT_REPORT_ERROR,
            payload: res?.data?.message || "Couldn't load the AI report.",
          });
          return;
        }
        dispatch({
          type: GET_ASSISTANT_REPORT_SUCCESS,
          payload: {
            board_id: res?.data?.board_id,
            report_board_id: res?.data?.report_board_id || res?.data?.board_id,
            assistant_summary: res?.data?.assistant_summary || {},
            export_links: res?.data?.export_links || {},
            visual_summary: res?.data?.visual_summary || {},
          },
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getAssistantReport(
              email,
              user,
              portfolio_type,
              market_type,
              mode,
              forceRegenerate,
              cardSnapshot,
              retryCount + 1,
            ),
          GET_ASSISTANT_REPORT_ERROR,
          user,
          email,
          formatTelegramLog("get_assistant_report", requestPayload, url),
          0,
          currentPath,
        );
      });
  };

export const getPrice =
  (
    email,
    user,
    symbol_name,
    market_type,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_PRICE_REQUEST });

    const url =
      "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email,
      user,
      market_type,
      request_type: "get_price",
      symbol_name,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_PRICE_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getPrice(email, user, symbol_name, market_type, retryCount + 1),
          GET_PRICE_ERROR,
          user,
          email,
          formatTelegramLog("assistant/get_price", data, url),
          0,
          currentPath,
        );
      });
  };
export const setTrade =
  (
    email,
    user,
    symbol_name,
    market_type,
    amount_native,
    trade_type,
    portfolio_type,
    native_or_usd,
    notif,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: SET_TRADING_REQUEST });

    const url =
      "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      request_type: "set_trade",
      email,
      user,
      market_type,
      symbol_name,
      amount_native,
      trade_type,
      portfolio_type,
      native_or_usd,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: SET_TRADING_SUCCESS, payload: res?.data });
        dispatch({ type: GET_PRICE_SUCCESS, payload: null });
        dispatch(getPortfolioData(email, user, portfolio_type));
        dispatch(setVirtualPortfolio(portfolio_type));
        dispatch(getTradeHistory(email, user, portfolio_type));

        if (notif) {
          notify("The transaction was successful", "success");
        }
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            setTrade(
              email,
              user,
              symbol_name,
              market_type,
              amount_native,
              trade_type,
              portfolio_type,
              native_or_usd,
              notif,
              retryCount + 1,
            ),
          SET_TRADING_ERROR,
          user,
          email,
          formatTelegramLog("assistant/set_trade", data, url),
          0,
          currentPath,
        );
      });
  };

export const get200Coins =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_200COINS_REQUEST });

    const url =
      "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email,
      user,
      request_type: "get_top_200_coins",
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_200COINS_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => get200Coins(email, user, retryCount + 1),
          GET_200COINS_ERROR,
          user,
          email,
          formatTelegramLog("get_top_200_coins", data, url),
          0,
          currentPath,
        );
      });
  };
// https://9mcsz8aaqg.execute-api.ap-southeast-2.amazonaws.com/dev/api
export const resetHistory =
  (
    email,
    user,
    portfolio_type,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: RESET_HISTORY_REQUEST });

    const url =
      "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email,
      user,
      request_type: "reset_trade_history",
      portfolio_type,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: RESET_HISTORY_SUCCESS, payload: res?.data });
        dispatch({ type: GET_TRADE_HISTORY_SUCCESS, payload: [] });
        dispatch(getPortfolioData(email, user, portfolio_type));
        notify("Your trade history cleared", "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => resetHistory(email, user, portfolio_type, retryCount + 1),
          RESET_HISTORY_ERROR,
          user,
          email,
          formatTelegramLog("assistant/reset_trade_history", data, url),
          0,
          currentPath,
        );
      });
  };

export const getBalanceChart =
  (
    email,
    user,
    portfolio_type,
    num_days_before,
    retryCount = 0,
    currentPath = window.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_BALANCE_REQUEST });

    const url =
      "https://hav8w1xk8h.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email,
      user,
      request_type: "get_balance_chart",
      portfolio_type,
      num_days_before,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_BALANCE_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getBalanceChart(
              email,
              user,
              portfolio_type,
              num_days_before,
              retryCount + 1,
            ),
          GET_BALANCE_ERROR,
          user,
          email,
          formatTelegramLog("assistant/get_balance_chart", data, url),
          0,
          currentPath,
        );
      });
  };

export const setLimitOrder =
  (
    email,
    user,
    portfolio_type,
    market_type,
    symbol_name,
    trade_type_list,
    trade_type_amount,
    trade_type_trigger_price,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: SET_LIMIT_ORDER_REQUEST });

    const url =
      "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      platform_mode: "trade_assistant",
      email,
      user,
      request_type: "set_trade",
      market_type,
      symbol_name,
      trade_type: "limit_orders",
      portfolio_type,
      trade_type_list,
      trade_type_amount,
      trade_type_trigger_price,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: SET_LIMIT_ORDER_SUCCESS,
          payload: res?.data?.Message,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            setLimitOrder(
              email,
              user,
              portfolio_type,
              market_type,
              symbol_name,
              trade_type_list,
              trade_type_amount,
              trade_type_trigger_price,
              retryCount + 1,
            ),
          SET_LIMIT_ORDER_ERROR,
          user,
          email,
          formatTelegramLog("limit_orders", data, url),
          0,
          currentPath,
        );
      });
  };

export const setAIMarketType = (market) => (dispatch) => {
  if (market !== "crypto") {
    tradeAssistantRequestSeq += 1;
    clearLiveSuggestionTimers();
  }
  dispatch({ type: SET_AI_MARKET_TYPE, payload: market });
};

export const updateAIPortfolioData = (data) => {
  return { type: UPDATE_PORTFOLIO_DATA, payload: data };
};

export const updateTradeAssistantData = (newValues) => {
  return { type: UPDATE_TRADE_ASSISTANT_DATA, payload: newValues };
};

export const setAiAssistantMode = (mode) => (dispatch) => {
  return dispatch({ type: SET_AI_ASSISTANT_MODE, payload: mode });
};

export const getAllTradeSuggestion =
  (
    user,
    email,
    market_type,
    isActive,
    processCode = "",
    retryCount = 0,
    currentPath = window.location?.href,
  ) =>
  async (dispatch, getState) => {
    dispatch({ type: GET_ALL_TRADE_SUGGESTION_REQUEST });

    const data = {
      platform_mode: "trade_assistant",
      user,
      email,
      market_type,
      request_type: "get_trade_suggestion",
      cache: "True",
      use_all_symbols: "True",
    };

    if (processCode) {
      data.process_code = processCode;
    }

    const url =
      "https://hav8w1xk8h.execute-api.ap-southeast-2.amazonaws.com/dev/api";

    await axios
      .post(url, data)
      .then((res) => {
        if (res?.data?.process_code) {
          setTimeout(() => {
            dispatch(
              getAllTradeSuggestion(
                user,
                email,
                market_type,
                isActive,
                res?.data?.process_code,
              ),
            );
          }, 20 * 1000);
        } else {
          dispatch({
            type: GET_ALL_TRADE_SUGGESTION_SUCCESS,
            payload: res?.data,
          });
        }
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getAllTradeSuggestion(
              user,
              email,
              market_type,
              processCode,
              retryCount + 1,
            ),
          GET_ALL_TRADE_SUGGESTION_ERROR,
          user,
          email,
          formatTelegramLog("get_trade_suggestion/all_symbols", data, url),
          0,
          currentPath,
        );
      });
  };

export const setViewType = (viewType) => ({
  type: "SET_VIEW_TYPE",
  payload: viewType,
});

export const setTimeFrame = (timeFrame) => ({
  type: SET_TIMEFRAME,
  payload: timeFrame,
});
